import { Validator } from 'vee-validate';
import { BasicSelect } from 'vue-search-select';
import CONSTANT from './../../../../shared/constants/constant';
import CryptoJS from 'crypto-js';
import ClientService from './../../../services/clientmanagement.service';
import VueElementLoading from 'vue-element-loading';
import MasterService from './../../../../masterdata/services/masterdata.service';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import Multiselect from 'vue-multiselect'
export default {
	name: 't-ccreation',
	components: {
		BasicSelect,
		VueElementLoading,
		Treeselect,
		Multiselect
	},
	props: ['CompanyShortList','selectedEditRowData','TcTemplateList'],
	data() {
		return {
			isLoading: false,
			username: '',
			selectedcompanyName: {
				"value": '',
				"text": ''
			},
			templatelist: [],
			selectedTemplate: {
				value: '',
				text: ''
			},
			tctemplate: '',
			billigDataList: [{
				id: CONSTANT.BILLING_DATA.MONTHLY,
				label: 'Monthly '
			}, {
				id: CONSTANT.BILLING_DATA.FORTNIGHTLY,
				label: 'Fortnightly'
			}, {
				id: CONSTANT.BILLING_DATA.WEEKLY,
				label: 'Weekly'
			}],
			billigcycleitem: {
				text: null,
				value: null
			},
			billingCycle: null,
			pod: '',
			date1: '',
			date2: '',
			podCharge: '',
			podChargeEnable: false,
			creditPeriod: '',
			creditLimit: '',
			advancePayment: '',
			creditAlert: '',
			paymentmode: [],
			liabilityAmount: '',
			cycleError: '',
			companyName: '',
			contractIdList: [],
			checkEdit: false,
			selectedContractId: {
				"value": '',
				"text": ''
			},
			contractId: '',
			clienttcid: '',
			expanded:false,
			accordianTab:{1:false, 2:false, 3:false},
			clientbusinessaccountid:''
		}
	},
	computed: {

	},
	mounted() {
		var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata');
		var userToken = window.localStorage.getItem('userToken');
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.username = userdetail.email;

		if(this.TcTemplateList.length>0){
			this.templatelist = this.TcTemplateList;
		}else{
			this.getTemplateList();
		}

		if(this.CompanyShortList.length>0){
		}else{
			this.getCompanyShortName();
		}

		if(this.selectedEditRowData.id) {
			this.checkEdit = true;
			this.clienttcid = this.selectedEditRowData.id;
			this.contractId = this.selectedEditRowData.clientcontractid;
			this.selectedcompanyName = {
				"value": this.selectedEditRowData.clientcontract.clientid,
				"text": this.selectedEditRowData.clientcontract.clientshortname,
			}
			this.companyShortName = this.selectedEditRowData.clientcontract.clientshortname;
			this.companyName = {
				"value": this.selectedEditRowData.clientcontract.clientid,
				"text": this.selectedEditRowData.clientcontract.clientshortname,
			}
			this.clientbusinessaccountid = this.selectedEditRowData.clientcontract.clientbusinessaccountid;
			this.getContractList(1);
			this.getclientTermsConditionDetails();
		}
	},
	methods: {
		isNumber: function(evt) {
			evt = (evt) ? evt : window.event;
			var charCode = (evt.which) ? evt.which : evt.keyCode;
			if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
			  evt.preventDefault();;
			} else {
			  return true;
			}
		},
		isIntegerOnlty: function(evt) {
			evt = (evt) ? evt : window.event;
			var charCode = (evt.which) ? evt.which : evt.keyCode;
			if (charCode < 48 || charCode > 57) {
			  evt.preventDefault();;
			} else {
			  return true;
			}
		},
		expandAll(){
			this.expanded = true;
			for (var key in this.accordianTab) {
				this.accordianTab[key] = true;
			}
		},
		collapseAll(){
			this.expanded = false;
			for (var key in this.accordianTab) {
				this.accordianTab[key] = false;
			}
		},
		toggleCheck(tabid){
			this.expanded = false;
			for (var key in this.accordianTab) {
				if(tabid != key){
					this.accordianTab[key] = false;
				}
			}
		},
		async getclientTermsConditionDetails() {
			this.isLoading = true;
			let input = {
				clienttcid: this.selectedEditRowData.id
			}
			let result = await ClientService.getclientTermsConditionDetails(input);
			var data = result.data.data[0]
			await this.setTemplatDetails(data);
			this.isLoading = false;
		},
		selectTemplate(template) {
			this.selectedTemplate = template;
			this.tctemplate = template.value;
			$("#selectTemplate").focus();
			this.resetAddForm();
			this.getTCTemplateDetail(template.value);
		},
		async getTemplateList() {
			this.isLoading = true;
			this.templatelist = []
			var result = await MasterService.getTemplateListForDropDown({})
			for (var i = 0; i < result.data.data.length; i++) {
				this.templatelist.push({
					text: result.data.data[i].termsconditionname,
					value: result.data.data[i].id
				})
			}
			this.isLoading = false;
		},
		async setTemplatDetails(data){
			for (var i = 0; i < this.templatelist.length; i++) {
				if (this.templatelist[i].value == data.tctemplateid) {
					this.selectedTemplate = this.templatelist[i];
					this.tctemplate = this.templatelist[i].value;
				}
			}
			this.billingCycle = data.billingcycle;
			this.pod = data.podhardcopyrequired;
			this.podCharge = data.podhardcopycharges;
			if (data.billingcycle == CONSTANT.BILLING_DATA.MONTHLY) {
				this.billigcycleitem = {
					id: CONSTANT.BILLING_DATA.MONTHLY,
					label: "Monthly"
				}
				this.billingCycle = CONSTANT.BILLING_DATA.MONTHLY;
				this.date1 = data.billsubmissionlastdate.cycle1;
				this.date2 = '';
			} else if (data.billingcycle == CONSTANT.BILLING_DATA.FORTNIGHTLY) {
				this.billigcycleitem = {
					id: CONSTANT.BILLING_DATA.FORTNIGHTLY,
					label: "Fortnightly"
				}
				this.billingCycle = CONSTANT.BILLING_DATA.FORTNIGHTLY;
				this.date1 = data.billsubmissionlastdate.cycle1;
				this.date2 = data.billsubmissionlastdate.cycle2;
			}else if (data.billingcycle == CONSTANT.BILLING_DATA.WEEKLY) {
				this.billigcycleitem = {
					id: CONSTANT.BILLING_DATA.WEEKLY,
					label: "Weekly"
				}
				this.billingCycle = CONSTANT.BILLING_DATA.WEEKLY;
			}
			this.creditPeriod = data.creditperioddays;
			this.creditLimit = data.creditlimit;
			this.advancePayment = data.ftladvancepayment;
			this.creditAlert = data.creditlimitalert;
			this.paymentmode = data.paymentmode;
			this.liabilityAmount = data.maxliability;
		},
		async getTCTemplateDetail(id) {
			this.isLoading = true;
			var input = {
				"tcid": id
			}
			var result = await MasterService.getTCTemplateDetail(input)
			var data = result.data.data[0];
			await this.setTemplatDetails(data);
			this.isLoading = false;
		},
		async selectContractId(data) {
			this.isLoading = true;
			this.selectedContractId = data;
			this.contractId = data.value;
			this.$refs.tctemplate.focus();
			var resultCheck = await ClientService.checkClientTermsConditionDetails({
				contractid: data.value
			})
			if (resultCheck.data.code == 200 && resultCheck.data.data.length>0) {
				this.$alert("T&C Template already exists for selected contract id "+data.text+". You can update details for the same.", "Terms And Conditions", "info");
				var data = resultCheck.data.data[0];
				this.clienttcid = data.clientcontractid;
				await this.setTemplatDetails(data);
				this.checkEdit = true;
			}
			this.isLoading = false;
		},
		selectBillingCycle(billingcycle) {
			this.$nextTick(() => {
				this.date1 = '';
				this.date2 = '';
				this.billigcycleitem = billingcycle
				this.billingCycle = billingcycle.id
			})
		},
		selectCompanyName(data) {
			this.selectedcompanyName = data;
			this.companyName = data.value;
			this.companyShortName = data.text;
			this.clientbusinessaccountid = data.ClientBusinessAccountId;
			this.getContractList();
		},
		async getContractList(obj) {
			try {
				this.contractIdList = [];
				if(!obj){
					this.contractId = "";
					this.selectedContractId = {};
				}
				this.isLoading = true;
				let inputPayload = {
					clientid: this.companyName,
					clientbusinessaccountid: this.clientbusinessaccountid
				};
				let result = await ClientService.getClientContractDropdownList(inputPayload);
				let contractlist = result.data.data;
				for (var i = 0; i < contractlist.length; i++) {
					if(contractlist[i].contractstatus==0){
						this.contractIdList.push({
							'value': contractlist[i].id,
							'text': contractlist[i].contractidlabel
						});
					}
					if(obj){
						if (contractlist[i].id == this.contractId) {
							this.selectedContractId = {
								'value': contractlist[i].id,
								'text': contractlist[i].contractidlabel
							}
						}
					}
				}
				this.isLoading = false;
			} catch (err) {
				console.log(err);
				this.isLoading = false;
			}
		},
		async getCompanyShortName() {
			try {
				this.isLoading = true;
				var CompanyShortList = []
				let result = await ClientService.getActiveInactiveClientList()
				CompanyShortList = getUniqueCompanyList(result.data.data);
				for (var i = 0; i < CompanyShortList.length; i++) {
					this.CompanyShortList.push({
						'value': CompanyShortList[i].ClientMasterID,
						'text': CompanyShortList[i].ClientShortName,
						'ClientBusinessAccountId': CompanyShortList[i].ClientBusinessAccountId
					})
				}
				this.isLoading = false;
			} catch (err) {
				console.log(err);
			}
		},
		getUniqueCompanyList(array){
			let mymap = new Map();
			let unique = array.filter(el => {
					const val = mymap.get(el.ClientMasterID);
					if(val) {
							if(el.ClientShortName < val) {
									mymap.delete(el.ClientMasterID);
									mymap.set(el.ClientMasterID, el.ClientShortName, el.ClientBusinessAccountId);
									return true;
							} else {
									return false;
							}
					}
					mymap.set(el.ClientMasterID, el.ClientShortName,el.ClientBusinessAccountId);
					return true;
			});
			return unique;
		},
		changeCycle() {
			if ((this.date1 == this.date2) && (this.date1 > 0 && this.date2 > 0)) {
				this.cycleError = "Dates should be Different"
				return false;
			} else {
				this.cycleError = ''
			}
		},
		onSubmit() {
			this.$validator.validateAll().then((result) => {
				if (!result) {
					return false;
				} else {
					if ((this.date1 == this.date2) && (this.date1 > 0 && this.date2 > 0)) {
						this.cycleError = "Dates should be Different"
						return false;
					} else {
						this.saveData()
					}
				}
			}).catch(() => {
				console.log('errors exist')
			});
		},
		async saveData() {
			this.isLoading = true;
			let billsubmissionlastdate = {}
			if (this.billingCycle == CONSTANT.BILLING_DATA.MONTHLY) {
				billsubmissionlastdate = {
					"cycle1": this.date1
				}
			} else if (this.billingCycle == CONSTANT.BILLING_DATA.FORTNIGHTLY) {
				billsubmissionlastdate = {
					"cycle1": this.date1,
					"cycle2": this.date2
				}
			}
			var payload = {
				"clientcontractid": this.contractId,
				"tctemplateid": this.tctemplate,
				"billingcycle": this.billingCycle || null,
				"podhardcopyrequired": this.pod || null,
				"podhardcopycharges": this.podCharge || null,
				"billsubmissionlastdate": billsubmissionlastdate,
				"creditperioddays": this.creditPeriod || null,
				"creditlimit": this.creditLimit || null,
				"ftladvancepayment": this.advancePayment || null,
				"creditlimitalert": this.creditAlert || null,
				"paymentmode": this.paymentmode,
				"maxliability": this.liabilityAmount || null,
				"status": 1,
				"lastmodifiedby": this.username
			}

			var result = await ClientService.saveclienttermsandcondition(payload);
			if (result.data.code == 200) {
				this.$alert(result.data.message, this.selectedcompanyName.text, "success");
				this.$emit("goBackToParent")
			} else {
				this.$alert(result.data.message, this.selectedcompanyName.text, "error");
			}
			this.isLoading = false;
		},
		resetAddForm() {
			this.$nextTick(() => {
				this.$validator.reset();
				this.isLoading = false;
				this.billigcycleitem = {
					value: '',
					text: ''
				};
				this.billingCycle = '';
				this.pod = '';
				this.podCharge = '';
				this.podChargeEnable = false;
				this.creditPeriod = '';
				this.creditLimit = '';
				this.date1 = '';
				this.date2 = '';
				this.advancePayment = '';
				this.paymentmode = [];
				this.liabilityAmount = '';
				this.creditAlert = '';
			})
		},
		showList() {
			this.$emit("goBackToParent")
		},
	}
}



// WEBPACK FOOTER //
// ./src/modules/clientmanagement/views/ClientTC/CreateClientTC/CreateClientTC.component.js